// Copyright 2025, University of Maryland, All Rights Reserved
import type { WorkspaceBill } from '@/types/workspace-bill'
import { ReportDialog } from '../ReportDialog'
import { useConfig } from '@/hooks/config/useConfig'
import type { JSONSchema } from '@/api/types/schema'

interface BillDialogProps {
  bill: WorkspaceBill | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function BillDialog({ bill, open, onOpenChange }: BillDialogProps) {
  const { config } = useConfig();
  if (!bill) return null
  
  // Get the dialog title from the monitor schema or use default
  const getDialogTitle = () => {
    const analysisTitle = monitor_schema?.title || "Analysis"
    return `${analysisTitle}: ${bill.bill_number}`
  }

  // Get the monitor schema from config
  const monitor_schema = config?.prompt_config?.monitor?.json_schema as JSONSchema | undefined;

  return (
    <ReportDialog
      title={getDialogTitle()}
      report_data={bill.monitor_analysis}
      open={open}
      onOpenChange={onOpenChange}
      isLoading={!bill.monitor_analysis}
      schema={monitor_schema}
    />
  )
}